import React from 'react'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import { IncidentStatus } from '../../../models/Incident'
import { TFunction } from 'i18next'

interface IncidentV2DetailsStepperProps {
    status: number
    translate: TFunction
}

export const IncidentV2DetailsStepper = ({ status, translate }: IncidentV2DetailsStepperProps) => {
    const getIncidentStatusStep = (status: IncidentStatus) => {
        switch (status) {
            case IncidentStatus.Pending:
                return 0
            case IncidentStatus.Open:
                return 1
            case IncidentStatus.Resolved:
                return 2
            default:
                return 0
        }
    }
    return (
        <Stepper
            activeStep={getIncidentStatusStep(status)}
            alternativeLabel
            nonLinear
            style={{}}
        >
            <Step>
                <StepLabel>{translate('customLabel_incidentStatusPending')}</StepLabel>
            </Step>
            <Step>
                <StepLabel>{translate('customLabel_incidentStatusOpen')}</StepLabel>
            </Step>
            <Step>
                <StepLabel>{translate('customLabel_incidentStatusResolved')}</StepLabel>
            </Step>
        </Stepper>
    )
}